import { PlusIcon, Trash01Icon } from '@langchain/untitled-ui-icons';

import * as React from 'react';

import { MultiSelect } from '@/components/MultiSelect';
import { PlainTextEditor } from '@/components/PlainTextEditor';
import { Tooltip } from '@/design-system';

export const MultiStringArray = (props: {
  value: unknown;
  onChange: (value: string[]) => void;
  enum: string[];
  placeholder?: string;
}) => {
  const safeValue =
    Array.isArray(props.value) &&
    props.value.every((x) => typeof x === 'string')
      ? props.value
      : [];

  if (props.enum.length === 0) {
    return (
      <div className="grid grid-cols-[1fr,auto] items-start gap-1.5">
        {safeValue.map((value, idx) => (
          <React.Fragment key={idx}>
            <PlainTextEditor
              className="w-full rounded-lg border border-secondary p-2 px-2.5 transition-colors focus-within:border-brand"
              textareaClassName="text-sm"
              placeholder="Input"
              value={value}
              onChange={(value) => {
                const newValue = [...safeValue];
                newValue[idx] = value;
                props.onChange(newValue);
              }}
            />

            <Tooltip title="Remove">
              <button
                type="button"
                className="flex h-[38px] w-[38px] flex-shrink-0 items-center justify-center rounded-lg border border-secondary p-1 outline-none transition-colors focus-within:border-brand hover:bg-secondary-hover"
                onClick={() => {
                  const newValue = [...safeValue];
                  newValue.splice(idx, 1);
                  props.onChange(newValue);
                }}
              >
                <Trash01Icon className="size-4" />
              </button>
            </Tooltip>
          </React.Fragment>
        ))}

        <div>
          <button
            type="button"
            className="flex items-center gap-1.5 rounded-lg border border-secondary px-2 py-1 text-sm outline-none transition-colors focus-within:border-brand hover:bg-secondary-hover"
            onClick={() => {
              props.onChange([...safeValue, '']);
            }}
          >
            <PlusIcon className="size-4" />
            <span>Add</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <MultiSelect
      placeholder={props.placeholder}
      value={safeValue}
      onChange={props.onChange}
      autocompleteList={props.enum.map((option) => ({
        id: option,
        display: option,
      }))}
      emptyState="No options available"
    />
  );
};
